import { type ReactNode } from "react";
import { cn } from "~/lib/utils";
import type { PlanColor } from "./_types";
import { PlanContext } from "./plan.context";

interface PlanRootProps {
  color: PlanColor;
  reversed?: boolean;
  children: Readonly<ReactNode>;
}

export default function PlanRoot({ children, color, reversed }: PlanRootProps) {
  return (
    <PlanContext.Provider value={{ color }}>
      <section className="bg-[#0d0d0d] py-20 overflow-x-hidden">
        <div
          className={cn(
            "mx-auto flex max-w-7xl items-center gap-12 px-4 flex-col",
            reversed === true
              ? "lg:flex-row"
              : "lg:flex-row-reverse",
          )}
        >
          {children}
        </div>
      </section>
    </PlanContext.Provider>
  );
}
